import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { useUser } from '../../hooks/use-user';
import {logout} from "../../services";
import {NavLink, useNavigate} from 'react-router-dom';

/**
 * @param {string} name the name to avatar
 */

const ResponsiveAppBar = () => {
  const { user, accessToken, setAccessToken } = useUser();
  const navigate = useNavigate()

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseLogerMenu = () => {
    logout(accessToken, (data) => {setAccessToken(null); navigate("/login");});
    handleCloseUserMenu();
  };

  const goTo = (option) => {
    handleCloseUserMenu();
    navigate(option);
  };

  const settings = [
    {
      text: 'Inicio',
      func: () => goTo('/home'),
      cond: () => true,
    },
    {
      text: 'Perfil',
      func: () => goTo('/user'),
      cond: () => true,
    },
    {
      text: 'Nueva contribución',
      func: () => goTo('/chargeaccount'),
      cond: () => (user && !user.coordinator),
    },
    {
      text: 'Cerrar sesión',
      func: () => handleCloseLogerMenu(),
      cond: () => true,
    },
  ];

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  function stringAvatar(name) {
    return {
      children: `${name.split(' ')[0][0]}`,
    };
  }

  return (
    <AppBar position="static" color="inherit">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
           {/*   MOBILE MENÚ  */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <NavLink to="/home" className="logo__link-app-bar"></NavLink>
          </Box>
          {/*   DESKTOP MENÚ   */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <NavLink to="/home" className="logo__link-app-bar"></NavLink>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <a className="link-app-bar-manual" target="_blank" rel="noreferrer" underline="none" href="https://reuniones.fundapap.org/static/media/Manual%20Fundapap%20v1.0.pdf">MANUAL</a>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              {
                user && user.name ? (
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar {...stringAvatar(`${user.name}`)} />
                </IconButton>
                ) : (
                  <div>
                    <NavLink className="link-app-bar" to="/login" underline="none">
                      {'INGRESAR'}
                    </NavLink>
                  </div>
                )
              }
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.filter((elem) => elem.cond()).map((setting) => (
                <MenuItem key={setting.text} onClick={setting.func}>
                  <Typography textAlign="center">{setting.text}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;
